import { render, staticRenderFns } from "./PddOrderInfoCard_With_Img.vue?vue&type=template&id=c3d15d6a&scoped=true&"
import script from "./PddOrderInfoCard_With_Img.vue?vue&type=script&lang=js&"
export * from "./PddOrderInfoCard_With_Img.vue?vue&type=script&lang=js&"
import style0 from "./PddOrderInfoCard_With_Img.vue?vue&type=style&index=0&id=c3d15d6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d15d6a",
  null
  
)

export default component.exports